import React from 'react';
import {Filter, TextInput, FilterProps} from 'react-admin';

const GrommetFilter = (props: Omit<FilterProps, 'children'>) => (
    <Filter {...props}>
        <TextInput source="matnr" alwaysOn/>
    </Filter>
);

export default GrommetFilter;
